<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <dashboard-net-line-chart />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DashboardNetLineChart from "@/views/DashboardNetLineChart";

export default {
  components: {DashboardNetLineChart},
  data () {
    return {
      type: 'month',
      types: ['month', 'week', 'day', '4day'],
      mode: 'stack',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      events: [],
      value: ''
    }
  },
  created() {
  },
  methods: {
  }
}
</script>
